import customerInstance from '../instance'

const updateCustomerEmail = (customerNumber, data) => {
	return customerInstance.put(`/customers/${customerNumber}/email`, data)
}

export default updateCustomerEmail
